import {Input as InputBase} from '@logistics-frontend/blocks'
import React, {useCallback} from 'react'
import {useController, useFormContext} from 'react-hook-form'

import type {Props} from './Input.type'

const normalize = (value?: string) => {
  if (value === undefined || value === '') {
    return ''
  }

  let hasDot = false
  let result = ''

  for (let i = 0; i < value.length; i++) {
    const char = value.charAt(i)

    // Проверка на минус только в начале строки
    if (char === '-' && i === 0) {
      result += char
      continue
    }

    // Даем ввести запятую или точку только один раз
    if ((char === '.' || char === ',') && !hasDot) {
      hasDot = true
      result += '.'
      continue
    }

    // Если символ - это число
    if (char >= '0' && char <= '9') {
      result += char
    }
  }

  return result
}

const finalization = (value: string) => {
  if (value.endsWith('.')) {
    value = value.slice(0, -1)
  }

  // Если строка начинается с точки, добавляем перед ней 0
  if (value.startsWith('.')) {
    value = '0' + value
  }

  return value
}

export function NumberInput({
  name,
  helperText,
  type,
  rules,
  shouldUnregister,
  defaultValue = '',
  ...otherProps
}: Props): React.ReactElement {
  const {control} = useFormContext()

  const {
    fieldState: {error},
    field: {value, onChange, onBlur},
  } = useController({control, name, rules, shouldUnregister, defaultValue})

  const handleChange = useCallback(
    (value: string) => {
      const normalizedValue = normalize(value)
      onChange(normalizedValue)
    },
    [onChange],
  )

  const handleBlur = useCallback(() => {
    const finalizedValue = finalization(value)
    onChange(finalizedValue)
    onBlur()
  }, [value, onBlur, onChange])

  return (
    <InputBase
      error={Boolean(error)}
      helperText={error?.message || helperText}
      name={name}
      onBlur={handleBlur}
      onChange={handleChange}
      value={value}
      {...otherProps}
    />
  )
}
